export const infoIconStyle = {
  fontSize: 17,
  color: '#4aa59a',
  display: 'inline-block',
  marginBottom: '3px',
};

export const cardTitle = {
  fontSize: 17,
  fontWeight: 400,
};

export const infoIconButton = {
  padding: 3,
};

export const viewDetailsButton = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  fontWeight: 500,
};

export const getInfoLink = () => {
  return 'https://support.airbtics.com';
};
